import { Component } from '@angular/core';
import {GameService} from "../../../services/game.service";
import {Subscription} from "rxjs";
import {GameModel} from "../../../models/game.model";
import {TrackingHelperService} from "../../../services/tracking-helper.service";
import {Game} from "../../../models/game.class";


@Component({
  selector: 'app-recommended-games',
  templateUrl: './recommended-games.component.html',
  styleUrls: ['./recommended-games.component.scss']
})
export class RecommendedGamesComponent {

  userhasTracker: boolean;
  identifierName: string = 'recommended';

  recommendedGames: Game[] = [];
  recommendedSubs?: Subscription;



  constructor(
    private gameService: GameService,
    private trackingService: TrackingHelperService
  ) {
    this.userhasTracker = !!this.trackingService.getTracker(); //user can have tracker only on server (removed from cookies)
    this.identifierName = this.userhasTracker ? 'recommended-for-user' : 'recommended-most-played'
    //todo ?have for you text for logged in users

    this.recommendedSubs?.unsubscribe();
    this.recommendedSubs = this.gameService.getRecommendedGames().subscribe(games => {
      this.recommendedGames = games;
    })

  }


  ngOnDestroy(){
    this.recommendedSubs?.unsubscribe();
  }



}
